export enum Language {
  FR,
  EN,
}
